export class LazyLoad {
    store = {
        locked: {}
    };
    /**
     * @param {IntersectionObserver}
     */
    lastObserver = null;

    /**
     * Default event
     */
    default() {
        window.addEventListener('load', () => {
            this.createObserver();
        });
        document.addEventListener('swup:content:replace', () => {
            this.createObserver();
        });
    }

    /**
     * Load bundle of svg of same url
     *
     * @param {DOMElement} element
     *
     * @returns {NodeList}
     */
    loadSVGs(element) {
        const url = element.getAttribute('rb-url');
        const svgs = document.querySelectorAll('svg[rb-url="' + url + '"]');
        this.fetchSVG(url, svgs);
        return svgs;
    }

    /**
     * Fetch svg and replace element
     *
     * @param {string} url 
     * @param {DOMElement} element 
     */
    async fetchSVG(url, elements) {
        if (this.lock('svg', url)) return;
        const data = await fetch(url).then((response) => {
            if (response.ok) {
                elements.forEach(svg => svg.removeAttribute('rb-url'));
                return response.text();
            }
            return null;
        });
        if (data === null) return;

        const parser = new DOMParser();
        const parsed = parser.parseFromString(data, 'image/svg+xml');
        
        let svg = parsed.getElementsByTagName('svg');
        if (svg.length > 0) {
            svg = svg[0];
            const attr = svg.attributes;
            const attrLength = attr.length;
            for (let i = 0; i < attrLength; i++) {
                if ('class' === attr[i].name) {
                    const classes = attr[i].value.replace(/\s+/g, ' ', trim().split(' '));
                    const classesLength = classes.length;
                    for (let j = 0; j < classesLength; j++) {
                        elements.forEach(element => element.classList.add(classes[j]));
                    }
                } else {
                    elements.forEach(element => element.setAttribute(attr[i].name, attr[i].value));
                }
            }
        }

        while (svg.childNodes.length) {
            let node = svg.childNodes[0].cloneNode(true);
            svg.removeChild(svg.childNodes[0]);
            elements.forEach(element => element.appendChild(node.cloneNode(true)));
        }
        this.unlock('svg', url);
    }

    /**
     * Create an observer and delete the last one.
     */
    createObserver() {
        const isLegacy = !('IntersectionObserver' in window);
        if (isLegacy) {
            this.legacy();
            return;
        }

        let observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting === false) return;

                const element = entry.target;
                let unobserved = null
                switch (element.tagName) {
                    case 'svg':
                        unobserved = this.loadSVGs(element);
                        break;
                    default:
                        console.warn(element.tagName + ' is not supported');
                        return;
                }

                unobserved.forEach(element => {
                    observer.unobserve(element);
                });
            });
        });
        let elements = document.querySelectorAll('svg[rb-url]');
        elements.forEach(element => observer.observe(element));
        if (this.lastObserver != null) {
            this.lastObserver.disconnect();
            delete this.lastObserver;
        }
        this.lastObserver = observer;
    }

    legacy() {
        let elements = document.querySelectorAll('svg[rb-url]');
        elements.forEach(element => {
            this.loadSVGs(element);
        });
    }

    /**
     * Lock a specific call
     *
     * @param {string} type Tag type
     * @param {string} id Identifier
     *
     * @returns {bool}
     */
    lock(type, id) {
        if (this.store.locked[type] == null) {
            this.store.locked[type] = [];
        }
        if (this.store.locked[type].includes(id)) return true;
        this.store.locked[type].push(id);
        return false;
    }

    /**
     * Unlock a specific call
     *
     * @param {string} type 
     * @param {string} id 
     */
    unlock(type, id) {
        const index = this.store.locked[type].indexOf(id);
        this.store.locked[type].splice(index, 1);
    }
}